var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"w-100"},[_c('b-row',_vm._l(([0, 1, 2, 3]),function(skeleton){return _c('b-col',{key:skeleton,staticClass:"mb-3",attrs:{"cols":"12"}},[_c('b-card',[_c('b-skeleton',{attrs:{"animation":"fade"}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }